export default function formatDate(date) {
  if (!date) return '';
  // Если нет Z или смещения, считаем что это UTC и добавляем Z
  const safeIso = /([Zz]|[+-]\d{2}:?\d{2})$/.test(date) ? date : date + 'Z';
  return new Date(safeIso).toLocaleString('ru-RU', {
    timeZone: 'Europe/Moscow',
    hour12: false,
  });
}
